/*eslint-disable */
import toast from '../../../services/toast';
import countries from '../../../services/country.json';
import allCountries from './phoneCodeList.json';
const $ = window.jQuery = require('jquery');
import {
  mapGetters
} from 'vuex';
export default {
  name: 'user-update',
  components: {},
  props: [],
  data() {
    return {
      submitted: false,
      first_name: '',
      last_name: '',
      email: '',
      division: '',
      activeStatus: Boolean,
      orgUserInfo: {},
      area_of_work:'',
      department:'',
      designation:'',
      countryList: [],
      country:'',
      city:'',
      allCountriesList:[],
      phone: {
        number: '',
        countryIso: '',
        countryCode:''
      },
      onCHangeCountryCode:'',
      sendingCountryCode:'',
      userFilter:'',
      oncologist:false,
      other_doctor:false,
      medical_researcher:false,
      patient:false
    }
  },
  computed: {
    ...mapGetters([
      'orgUserDetailsByIdGetters'
    ]),
    getUserInfoByIdFun() {
      this.orgUserInfo = this.$store.getters.orgUserDetailsByIdGetters.data
      return
    },
     SetIntialStatus() {
      if(this.orgUserInfo != undefined){
        this.first_name = this.orgUserInfo.first_name
        this.last_name = this.orgUserInfo.last_name
        this.email = this.orgUserInfo.email
        this.area_of_work = this.orgUserInfo.profile.area_of_work
        this.department = this.orgUserInfo.profile.department
        this.designation = this.orgUserInfo.profile.designation
        this.division = this.orgUserInfo.profile.division
        this.country = this.orgUserInfo.profile.country
        this.city = this.orgUserInfo.profile.city
        this.activeStatus = this.orgUserInfo.is_active
        this.oncologist = this.orgUserInfo.profile.oncologist
        this.other_doctor = this.orgUserInfo.profile.other_doctor
        this.medical_researcher = this.orgUserInfo.profile.medical_researcher
        this.patient = this.orgUserInfo.profile.patient
        this.phone.countryCode = this.orgUserInfo.profile.mobile_country_code  || '+91'
        this.phone.number = this.orgUserInfo.profile.mobile
        setTimeout(()=>{
        if(this.phone.countryCode != null && this.phone.countryCode != ''){
          var countrySplit = this.phone.countryCode
          var phoneCountry = countrySplit.replace('+', '');
          this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
          }
        },100)
        setTimeout(()=>{
          if(this.oncologist == true){
            this.userFilter = 'oncologist'
          }else if(this.other_doctor == true){
            this.userFilter = 'other_doctor'
          }else if(this.medical_researcher == true){
            this.userFilter = 'medical_researcher'
          }else if(this.patient == true){
            this.userFilter = 'patient'
          }else{
            this.userFilter = ''
          }
        },100)
      }
      return
    }
  },
    mounted() {
      Object.keys(countries).map((key, index) => {
        this.countryList.push({
          name: countries[key].toLowerCase(),
          value: key.toLowerCase()
        })
      });
      this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
      for (var i = 0; i < allCountries.length; i++) {
        let c = allCountries[i];
        this.allCountriesList.push({
          name: c[0],
          iso2: c[1],
          dialCode: c[2],
          priority: c[3] || 0,
          areaCodes: c[4] || null
        });
      }
      this.getUserInfoByIdFun
      this.SetIntialStatus
      $('.option-list').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $(this).find('ul').slideToggle(100);
        if ($(this).hasClass('open')) {
          $('.dropdown-arrow').text('▼');
        } else {
          $('.dropdown-arrow').text('▲');
        }
      });
      $(document).on('click', function(e) {
        var container = $('.option-list');
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.removeClass('open');
          $('.dropdown-arrow').text('▲');
          container.find('ul').slideUp(100);
        }
      })
    },
    methods: {
      chooseCountry(country) { 
        this.phone.countryIso = country.iso2;
        this.onCHangeCountryCode = country.dialCode
      },
      FilterFieldChangeFun(){
        console.log(this.userFilter, "CHeanged")
        if(this.userFilter == 'oncologist'){
          this.oncologist = true
         }else{
           this.other_doctor = false
           this.medical_researcher = false
           this.patient = false
         }
         if(this.userFilter == 'other_doctor'){
           this.other_doctor = true
         }else{
           this.oncologist = false
           this.medical_researcher = false
           this.patient = false
         }
        if(this.userFilter == 'medical_researcher'){
          this.medical_researcher = true
         }else{
           this.oncologist = false
           this.other_doctor = false
           this.patient = false
         }
         if(this.userFilter == 'patient'){
          this.patient = true
         }else{
           this.oncologist = false
           this.other_doctor = false
           this.medical_researcher = false
         }
      },
      validateBeforeSubmit(e) {
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            if(this.onCHangeCountryCode != ''){
              this.sendingCountryCode = '+' + this.onCHangeCountryCode
            }else{
              this.sendingCountryCode = this.phone.countryCode
            }
            if(this.userFilter == 'oncologist'){
              this.oncologist = true
             }else if(this.userFilter == 'other_doctor'){
               this.other_doctor = true
             }else if(this.userFilter == 'medical_researcher'){
              this.medical_researcher = true
             }else if(this.userFilter == 'patient'){
              this.patient = true
             }
            let data = {
              email: this.email,
              first_name: this.first_name,
              last_name: this.last_name,
              profile: {
                area_of_work: this.area_of_work,
                department: this.department,
                designation: this.designation,
                country: this.country,
                city: this.city,
                mobile_country_code:this.sendingCountryCode,
                mobile: this.phone.number,
                division: this.division,
                oncologist:this.oncologist,
                other_doctor:this.other_doctor,
                medical_researcher:this.medical_researcher,
                patient:this.patient
              },
              is_active:this.activeStatus
            }
            this.$store.dispatch('updateOrgUseDetailsByIdFun', {
              data: {
                data: data,
                id: this.$route.params.updateUserID
              }
            })
              .then((res) => {
                  toast.success(res.data.msg);
                  this.$router.push({ name: 'usersList'})
              }).catch((err) => {
                toast.error(err.data.data.email);
              })
            return;
          }
        });
      }
    },
    watch: {
      getUserInfoByIdFun() {
        return this.$store.getters.orgUserDetailsByIdGetters.data
      },
      SetIntialStatus() {
        if(this.orgUserInfo != undefined){
          this.first_name = this.orgUserInfo.first_name
          this.last_name = this.orgUserInfo.last_name
          this.email = this.orgUserInfo.email
          this.area_of_work = this.orgUserInfo.profile.area_of_work
          this.department = this.orgUserInfo.profile.department
          this.designation = this.orgUserInfo.profile.designation
          this.division = this.orgUserInfo.profile.division
          this.country = this.orgUserInfo.profile.country
          this.city = this.orgUserInfo.profile.city
          this.activeStatus = this.orgUserInfo.is_active
          this.phone.countryCode = this.orgUserInfo.profile.mobile_country_code  || '+91'
          this.phone.number = this.orgUserInfo.profile.mobile
          setTimeout(()=>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode
            var phoneCountry = countrySplit.replace('+', '');
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
            }
          },100)
          setTimeout(()=>{
            if(this.oncologist == true){
              this.userFilter = 'oncologist'
            }else if(this.other_doctor == true){
              this.userFilter = 'other_doctor'
            }else if(this.medical_researcher == true){
              this.userFilter = 'medical_researcher'
            }else if(this.patient == true){
              this.userFilter = 'patient'
            }else{
              this.userFilter = ''
            }
          },100)
        }
        return
      }
    },
    beforeRouteLeave: function (to, from, next) {
      next();
    },
}